module.exports = fox._r("images/slides/slide_2_5.jpg", __webpack_public_path__ + "images/slides/slide_2_5.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_2_5.jpg
// module id = 513
// module chunks = 2